import React, { useRef, useState } from "react";
import "./index.scss";
import OnboardingForm from "../../molecules/onboarding-form";
import IntroductionText from "../../../../../../../../design/1/js/templates/molecules/introduction-text";
import JsonResponse from "../../../../../../../../design/1/js/lib/entity/response/JsonResponse";
import MessageContext from "../../../../../../../../design/1/js/lib/entity/response/MessageContext";
import Button, { ButtonType } from "../../../../../../../../design/1/js/templates/atoms/button";
import Modal from "../../../../../../../../design/1/js/templates/molecules/modal";
import Accordion, { AccordionType } from "../../../../../../../../design/1/js/templates/molecules/accordion";
import AccordionData from "../../../../../../../../design/1/js/templates/molecules/accordion/lib/AccordionData";
import SwissIdEmail from "../../molecules/swiss-id-email";

interface OnboardingProps {
    agbText: string;
    actionUrl: string;
    swissIdEmail: string;
    swissIdEmailUrl: string;
    supportFormLink: string;
    homepageLinkAction: string;
    linkAccessDataForm: string;
    linkChangeSwissIdEmail: string;
}


const Onboarding = ({
    actionUrl, agbText, swissIdEmail, swissIdEmailUrl, supportFormLink, homepageLinkAction, linkAccessDataForm, linkChangeSwissIdEmail
}: OnboardingProps) => {
    const refreshEmail = useRef(true);
    const [formSubmit, setFormSubmit] = useState(false);
    const [isHelpModalOpen, setHelpModalOpen] = useState(false);
    const baseClassName = 'w-onboarding';

    const accordionItems : AccordionData[] = [
        {
            id: '1',
            title: window.sv_resource.get("plf_onboarding_popup_access_data_title"),
            description: window.sv_resource.get('plf_onboarding_popup_access_data_description').replace('{{linkAccessDataForm}}', linkAccessDataForm),
        },
        {
            id: '2',
            title: window.sv_resource.get("plf_onboarding_popup_help_desk_title"),
            description: window.sv_resource.get('plf_onboarding_popup_help_desk_description').replace('{{supportFormLink}}', supportFormLink),
        },
        {
            id: '3',
            title: window.sv_resource.get("plf_onboarding_popup_swissid_title"),
            description: window.sv_resource.get('plf_onboarding_popup_swissid_description').replace('{{swissIdContactLink}}', window.sv_resource.get('plf_onboarding_infobox_swissid_link')),
        },
    ];

    const handleFormSubmit = (status: number) => {
        setFormSubmit(true);
        refreshEmail.current = false;

        // Don't redirect after error, otherwise the user can't read the message.
        if (status !== 200) {
            return;
        }

        setTimeout(async () => {
            const response: JsonResponse<MessageContext> = await fetch(homepageLinkAction, {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                    'X-Csrf-Token': document.body.dataset.csrfToken,
                },
            }).then(res => res.json());

            window.location.href = response.context.message;
        }, 5000);
    };
    return (
        <div className={`${baseClassName}`}>
            { !formSubmit && (
                <div className={`col-12 col-sm-9 col-lg-7 mx-auto`}>
                    <IntroductionText description={window.sv_resource.get('plf_onboarding_introduction_description')} title={window.sv_resource.get('plf_onboarding_introduction_title')} />
                    <SwissIdEmail actionUrl={swissIdEmailUrl} changeLink={linkChangeSwissIdEmail} email={swissIdEmail} refreshEmail={refreshEmail} />
                </div>
            )}
            <div className={`${baseClassName}-wrapper`}>
                <OnboardingForm actionUrl={actionUrl} agbText={agbText} handleSubmit={handleFormSubmit}/>
                { !formSubmit && (
                    <p className={`mt-2 col-12 col-sm-9 col-lg-7 mx-auto`}>
                        {window.sv_resource.get('plf_onboarding_popup_link_text_prefix')} <Button handleClick={() => setHelpModalOpen(true)} className={`d-inline-block`} hasArrow={false} type={ButtonType.Link} text={window.sv_resource.get('plf_onboarding_popup_link_text')}/>
                    </p>
                )}
                <Modal isOpen={isHelpModalOpen} setIsOpen={setHelpModalOpen} title={window.sv_resource.get('plf_onboarding_popup_title')}>
                    <Accordion data={accordionItems} type={AccordionType.Bold} />
                </Modal>
            </div>
        </div>
    );
};

export default Onboarding;
